import { Card, CardContent } from "../components/ui/card";
import { Menu } from "../components/ui/menu";
import Impersonate from "../components/ui/impersonate";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Markdown from "react-markdown";
import { Components } from 'react-markdown';
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter"
import { dark } from "react-syntax-highlighter/dist/esm/styles/prism"
import rehypeKatex from 'rehype-katex'
import remarkMath from 'remark-math'
import remarkGfm from 'remark-gfm'
import 'katex/dist/katex.min.css'
import { API } from "../config";
import { MarkdownA, MarkdownHeading1, MarkdownHeading2, MarkdownHeading3 } from "./MarkdownPage"; // `rehype-katex` does not import the CSS for you

type MarkdownH1Props = Components['h1'];

export default function HelpPage() {
  const navigate = useNavigate();

  const [sourceMarkdownText, setSourceMarkdownText] = useState('');
  const [impersonateMessage, setImpersonateMessage] = useState<string>("");
  const [impersonate, setImpersonate] = useState<string>("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const refreshHelp = () => {
    fetch(API.DOC_HELP)
      .then(res => res.json())
      .then((res) => {
        let announces: string = "";
        Object.entries(res?.public).reverse().map(([id, post]: [string, any]) => {
          // {id: string; title?: string; date?: string; body: string, enable?: boolean}
          if (post?.enable === true) {
            announces += "## " + (post?.title || "") + (post?.date ? `(${post?.date})` : "") + "\n";
            announces += (post?.body || "") + "\n";
          }
        });

        setSourceMarkdownText(announces);
      }).catch((error) => {
      setError("Помилка завантаження допомоги");
      console.error("Error fetching help data:", error);
    });
  };

  useEffect(() => {
    let impersonate: string | null = null;
    try {
      impersonate = localStorage.getItem("impersonate");
    } catch (e) {
      console.error("Error reading impersonate from localStorage:", e);
      impersonate = null; // Default to null if there's an error
    }
    if (impersonate) {
      setImpersonate(impersonate);
      setImpersonateMessage(`Обліковий запис ${impersonate}`);
    }
    refreshHelp();
  }, []);

  return (
    <Menu>
      <div className="">
        <Impersonate message={impersonateMessage} callbackExit={() => {
          try {
          localStorage.removeItem("impersonate");
          } catch (e) {
            console.error("Error removing impersonate from localStorage:", e);
          }
          setImpersonateMessage("");
          navigate("/users");
        }}/>
        <Card className="w-full max-w-xl mb-6 rounded-2xl shadow-lg">
          <CardContent>
            <h1 className="text-2xl font-semibold mb-6 text-center">Допомога</h1>
            {/*<p className="text-center text-gray-600 mb-4"><strong>Roles:</strong> {profile?.roles?.join(", ")}</p>*/}

            {error && <p className="text-red-500 text-sm text-center">{error}</p>}
            {success && <p className="text-green-600">{success}</p>}

            <div className="">

              <div className="overflow-auto">
                <Markdown
                  remarkPlugins={[remarkGfm, remarkMath]}
                  rehypePlugins={[rehypeKatex]}
                  children={sourceMarkdownText}
                  components={{
                    h1: MarkdownHeading1,
                    h2: MarkdownHeading2,
                    h3: MarkdownHeading3,
                    a: MarkdownA,
                    p: ({ node, className, children, ...props }) => (
                      <p className={`my-4 ${className || ''}`} {...props}>
                        {children}
                      </p>
                    ),
                    blockquote: ({ node, className, children, ...props }) => (
                      <blockquote className={`border-l-4 border-gray-300 pl-4 italic ${className || ''}`} {...props}>
                        {children}
                      </blockquote>
                    ),
                    ul: ({ node, className, children, ...props }) => (
                      <ul className={`list-decimal pl-6 my-4 ${className || ''}`} {...props}>
                        {children}
                      </ul>
                    ),
                    code(props) {
                      const { children, className, node, ref, ...rest } = props;
                      return (
                        <SyntaxHighlighter
                          {...rest}
                          PreTag="pre"
                          style={dark}
                        >
                          {String(children).replace(/\n$/, '')}
                        </SyntaxHighlighter>
                      );
                    }
                  }}
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </Menu>
  );
}
